<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'spACE Email Malformed Accounts'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
            <ng-container *ngIf="this.badSpaceAccountList.length == 0">
                <span>No Malformed spACE accounts found.  All looks good.</span>
            </ng-container>


                <ng-container *ngIf="this.badSpaceAccountList.length > 0">
                <div style="margin-top:30px;"></div>
                <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;margin-bottom:10px;">
                    Number of Malformed SpaceEmail Accounts: {{badSpaceAccountList.length}}    
                </div>

                <div>
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onUpdateAndFixSpaceEmailAccounts()">Correct these spACE Account(s)</button>
                </div>

                <igx-grid #gridAgingReport id="gridAgingReport" [igxPreventDocumentScroll]="true" [data]="badSpaceAccountList" [height]="'720px'" [width]="'100%'" [autoGenerate]="false"
                [primaryKey]="'spaceEmailId'" [cellSelection]="'none'" [rowEditable]="false" style="margin-top:30px;">

                <igx-column field="spaceEmailId" header="Space Email Id"  width="225px" [sortable]="true"></igx-column>
                <igx-column field="spaceUserId" header="Space User Id"  width="225px" [sortable]="true"></igx-column>
                <igx-column field="emailAddress" header="Email Address"  width="325px" [sortable]="true"></igx-column>
                <igx-column field="dateLastModified" header="Date Last Modified" width="350px" required [sortable]="true" >
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            {{value | date: 'long'}}
                               
                        </div>
                    </ng-template>
                </igx-column>

                <igx-column field="entityIdType" header="Profile Type" width="200px" required [sortable]="true" >
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            
                                @if(value == '0')
                                {
                                   Parker
                                }
                                @else {
                                   Company
                                }
                        </div>
                    </ng-template>
                </igx-column>
           
                <igx-column field="lotNumber" header="Lot Number"  width="225px" [sortable]="true"></igx-column>
           
            

            <igx-grid-toolbar>
            <igx-grid-toolbar-actions>
            <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
            <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
            <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
            </igx-grid-toolbar-actions>
            </igx-grid-toolbar>

         

            </igx-grid>


</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>

